// extracted by mini-css-extract-plugin
module.exports = {"nbBtn":"CommonButton_nbBtn__wLDst","bgAni":"CommonButton_bgAni__wW2h3","bgLoopAni":"CommonButton_bgLoopAni__Cp4pG"};